import {
    Button,
    Card,
    EmptyState,
    ErrorAlert,
    Modal,
    PageHeader,
    useFormatters,
    useDisclosure,
    useTenantQueryKey,
} from '@lumlab/platform-ui';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { apiRequest } from '@lumlab/platform-product/web';
import type { Agency } from '../contract/index.ts';
import { AgencyForm } from './AgencyForm.tsx';

export function AgenciesPage() {
    const { t } = useTranslation();
    const format = useFormatters();
    const { opened, open, close } = useDisclosure();
    const agenciesKey = useTenantQueryKey('tenders', 'agencies');
    const agencies = useQuery({
        queryKey: agenciesKey,
        queryFn: ({ signal }) => apiRequest<{ agencies: Agency[] }>('/api/tenders/agencies', { signal }),
    });

    return (
        <>
            <PageHeader
                title={t('tenders.agencies.title')}
                description={t('tenders.agencies.description')}
                actions={<Button onClick={open}>{t('tenders.agencies.add')}</Button>}
            />
            {agencies.error && <ErrorAlert error={agencies.error} />}
            {agencies.data && agencies.data.agencies.length === 0 && (
                <EmptyState title={t('tenders.agencies.empty')} description={t('tenders.agencies.emptyDescription')} />
            )}
            {agencies.data && agencies.data.agencies.length > 0 && (
                <div className="flex flex-col gap-4">
                    <p className="text-muted">
                        {t('tenders.agencies.count', { count: agencies.data.agencies.length })}
                    </p>
                    {agencies.data.agencies.map((agency) => (
                        <Card key={agency.id}>
                            <p className="font-semibold">{agency.name}</p>
                            {agency.address && <p>{agency.address}</p>}
                            <p className="text-sm text-muted">
                                {t('tenders.agencies.createdAt', { date: format.date(new Date(agency.createdAt)) })}
                            </p>
                        </Card>
                    ))}
                </div>
            )}
            <Modal opened={opened} onClose={close} title={t('tenders.agencies.add')}>
                <AgencyForm onDone={close} endpoint="/api/tenders/agencies" queryKey={agenciesKey} />
            </Modal>
        </>
    );
}
